import { LocalDate } from '../../../core/pojo/date-variable';

export class MetricData {
  uuid: string;
  rowValue: string;
  period: LocalDate;
  role: MetricDataRole = MetricDataRole.ACTUAL;
  periodType: MetricPeriodType = MetricPeriodType.MONTHLY;
}

export const METRIC_DATA_STRING_LIMIT = 1024;

export enum MetricPeriodType {
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
}

export enum MetricDataRole {
  BUDGET = 'Budget',
  ACTUAL = 'Actual',
}

export const MetricDataRoleMap = new Map<string, MetricDataRole>(
  [['Actual', MetricDataRole.ACTUAL], ['Budget', MetricDataRole.BUDGET]]);

export const MetricDataRoleByNameMap = new Map<{name: string}, MetricDataRole>(
  [[{ name: 'Actual' }, MetricDataRole.ACTUAL], [{ name: 'Budget' }, MetricDataRole.BUDGET]]);

export const isRowValueEmpty = (rawValue: string): boolean => {
  return !rawValue || rawValue === '' || rawValue === '0' || rawValue === '0.0';
};
